// Vite env gate for Google Calendar integration visibility.
export const GCAL_ENABLED = import.meta.env.VITE_GCAL_ENABLED === 'true';
